<div class="stats-block"><div class="stats-block__title">{{ $t('Статистика') }}</div></div>